(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canvaspalette-ai-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cp-multipanel-slideshow')) {
    customElements.define('cp-multipanel-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.cp-home-slide-track');
        const slides = this.querySelectorAll('.cp-home-slide');
        const previous = this.querySelector('[data-slide-prev]');
        const next = this.querySelector('[data-slide-next]');
        const counter = this.querySelector('[data-slide-current]');
        const toggle = this.querySelector('[data-slide-toggle]');
        const icon = this.querySelector('[data-slide-toggle-icon]');
        if (!track || !slides.length || !previous || !next || !counter || !toggle) return;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let paused = reduced.matches;
        let hovering = false;
        let current = 0;
        const stop = () => { clearInterval(this.timer); this.timer = null; };
        const update = () => {
          current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          counter.textContent = String(current + 1);
          previous.disabled = current === 0;
          next.disabled = current === slides.length - 1;
        };
        const go = (index) => {
          track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, index)) * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth'});
        };
        const sync = () => {
          stop();
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          icon.textContent = paused ? '▶' : 'Ⅱ';
          counter.parentElement.setAttribute('aria-live', paused ? 'polite' : 'off');
          if (!paused && !hovering && !document.hidden) this.timer = setInterval(() => go((current + 1) % slides.length), 3000);
        };
        const manual = (index) => { go(index); sync(); };
        previous.addEventListener('click', () => manual(current - 1), {signal});
        next.addEventListener('click', () => manual(current + 1), {signal});
        toggle.addEventListener('click', () => { paused = !paused; sync(); }, {signal});
        track.addEventListener('scroll', update, {passive: true, signal});
        track.addEventListener('pointerdown', () => { paused = true; sync(); }, {signal});
        this.addEventListener('mouseenter', () => { hovering = true; sync(); }, {signal});
        this.addEventListener('mouseleave', () => { hovering = false; sync(); }, {signal});
        this.addEventListener('focusin', (event) => { if (!toggle.contains(event.target)) { paused = true; sync(); } }, {signal});
        document.addEventListener('visibilitychange', sync, {signal});
        reduced.addEventListener('change', () => { if (reduced.matches) paused = true; sync(); }, {signal});
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          const destinations = {ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: slides.length - 1};
          if (!(event.key in destinations)) return;
          event.preventDefault();
          manual(destinations[event.key]);
        }, {signal});
        this.dataset.ready = 'true';
        update();
        sync();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
        this.controller = null;
        delete this.dataset.ready;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canvaspalette-ai-studio"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const maxPhotoBytes=20*1024*1024;
  let heicLoader=null;
  function loadHeicDecoder(message){
    if(typeof window.HeicTo==='function')return Promise.resolve(window.HeicTo);
    if(!heicLoader)heicLoader=new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.src='https://cdn.jsdelivr.net/npm/heic-to@1.5.2/dist/iife/heic-to.js';
      script.integrity='sha384-cVm8gaWQ5+URpoh6ACKXpm8TuyoHkfIDDBkxvDoUdIZ18w8nV5en0lVQvWMwO/6S';script.crossOrigin='anonymous';
      const fail=()=>{clearTimeout(timer);script.remove();heicLoader=null;reject(Error(message));};
      const timer=setTimeout(fail,30000);
      script.onload=()=>{if(typeof window.HeicTo!=='function')return fail();clearTimeout(timer);resolve(window.HeicTo);};
      script.onerror=fail;document.head.append(script);
    });
    return heicLoader;
  }
  class CanvasPaletteStudio {
    constructor(root){
      if(root.dataset.initialized)return;root.dataset.initialized='true';this.root=root;
      this.t=JSON.parse(root.parentElement.querySelector('[data-studio-translations]').textContent);
      this.q=s=>root.querySelector(s);this.qa=s=>[...root.querySelectorAll(s)];
      this.demo=root.dataset.preview==='true';this.base=root.dataset.endpoint;this.assets=[];this.selected=null;this.reference=null;this.credits=3;this.busy=false;this.mode='idea';
      this.q('[data-preview-bar]').hidden=!this.demo;this.q('[data-gallery-count]').textContent=this.t.private_gallery;
      this.qa('[data-login-link]').forEach(a=>a.href=root.dataset.login);
      this.bind();void this.load();
    }
    status(message,error=false){this.q('[data-status]').textContent=message;this.q('[data-status]').dataset.error=String(error);}
    async api(path,options={}){
      const headers={'Accept':'application/json',...(this.session?.csrf?{'X-Studio-CSRF':this.session.csrf}:{}),...options.headers};
      const r=await fetch(this.base+path,{credentials:'same-origin',cache:'no-store',...options,headers});
      const data=await r.json();if(!r.ok){const e=Error(data.error||this.t.connection_error);e.status=r.status;throw e;}return data;
    }
    async load(){
      if(this.demo){this.session={credits:3,generationEnabled:true,paymentsEnabled:true};this.updateBalance();return;}
      try{
        this.session=await this.api('/session');this.credits=this.session.credits;this.assets=this.session.assets;this.renderGallery();this.updateBalance();
        this.q('[data-gate]').hidden=true;this.q('[data-login-link]').textContent=this.t.studio_account;
        const selected=this.assets.find(asset=>asset.id===this.selected?.id)||this.assets[0];
        if(selected)this.select(selected);
        if(this.session.coupon){this.q('[data-coupon]').hidden=false;this.q('[data-coupon]').textContent=this.t.coupon_message.replace('{code}',this.session.coupon);}
        if(!this.session.generationEnabled)this.status(this.t.unavailable);
        const pending=this.session.jobs?.[0];if(pending&&!this.polling)void this.poll(pending.id);
      }catch(e){if(e.status===401||e.status===403)this.q('[data-gate]').hidden=false;else this.status(this.t.unavailable);}
    }
    updateBalance(){this.q('[data-balance]').textContent=Math.max(0,this.credits);}
    lock(value){this.busy=value;this.qa('[data-generate], [data-upload], [data-file], [data-consent], [data-mode], [data-revise], [data-clear-reference]').forEach(el=>el.disabled=value);this.q('[data-room]').classList.toggle('is-loading',value);this.q('[data-generate-label]').textContent=value?this.t.working_label:this.t.create_art;}
    setMode(mode){this.mode=mode;this.qa('[data-mode]').forEach(b=>{b.classList.toggle('is-active',b.dataset.mode===mode);b.setAttribute('aria-pressed',String(b.dataset.mode===mode));});this.q('[data-upload-panel]').hidden=mode!=='photo';}
    bind(){
      this.qa('[data-mode]').forEach(b=>b.addEventListener('click',()=>this.setMode(b.dataset.mode)));
      this.qa('[data-example]').forEach(b=>b.addEventListener('click',()=>{this.q('[data-prompt]').value=this.t['example_'+b.dataset.example];this.q('[data-prompt]').focus();}));
      this.q('[data-file]').addEventListener('change',()=>this.selectPhoto(this.q('[data-file]').files[0]));
      this.q('[data-upload]').addEventListener('click',()=>void this.upload());
      this.q('[data-clear-reference]').addEventListener('click',()=>void this.clearReference());
      this.q('[data-generate]').addEventListener('click',()=>void this.generate());
      this.q('[data-revise]').addEventListener('click',()=>{
        if(!this.selected)return this.status(this.t.choose_artwork,true);
        this.setReference(this.selected);this.setMode('idea');this.q('[data-prompt]').value='';this.q('[data-prompt]').placeholder=this.t.change_placeholder;this.q('[data-prompt]').focus();this.status(this.t.refine_ready);
      });
      this.q('[data-buy-credits]').addEventListener('click',()=>void this.checkout('credits'));
      this.q('[data-download]').addEventListener('click',()=>{
        if(!this.selected)return this.status(this.t.choose_artwork,true);
        if(this.selected.download&&!this.demo){location.assign(this.base+'/assets/'+this.selected.id+'/download');return;}
        void this.checkout('digital');
      });
      this.q('[data-canvas]').addEventListener('click',()=>{
        if(!this.selected)return this.status(this.t.choose_artwork,true);
        if(this.demo)return this.status(this.t.sample_canvas);
        const url=new URL('/products/canvas-prints-photo-portrait',location.origin);url.searchParams.set('view','canvaspalette-ai-builder');url.searchParams.set('studio_artwork',this.selected.id);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        location.assign(url.href);
      });
      document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible'&&!this.demo&&!this.busy)void this.load();});
      window.addEventListener('pageshow',event=>{if(event.persisted&&!this.demo&&!this.busy)void this.load();});
    }
    async convertHeic(file){
      const convert=await loadHeicDecoder(this.t.heic_load_failed);let timer;
      try{
        const blob=await Promise.race([(async()=>{
          if(!await convert.isHeic(file))throw Error(this.t.heic_failed);
          return convert({blob:file,type:'image/jpeg',quality:.98});
        })(),new Promise((_,reject)=>{timer=setTimeout(()=>reject(Error(this.t.heic_timeout)),90000);})]);
        if(!blob?.size||blob.type!=='image/jpeg')throw Error(this.t.heic_failed);
        if(blob.size>maxPhotoBytes)throw Error(this.t.heic_too_large);
        return new File([blob],file.name.replace(/\.(heic|heif)$/i,'')+'-converted.jpg',{type:'image/jpeg'});
      }finally{clearTimeout(timer);}
    }
    async selectPhoto(file){
      if(this.busy||!file)return;
      this.file=null;this.reference=null;this.q('[data-reference]').hidden=true;this.q('[data-local-photo]').hidden=true;this.q('[data-consent]').checked=false;this.setMode('photo');
      if(this.localURL){URL.revokeObjectURL(this.localURL);this.localURL=null;}
      const isHeic=/\.(heic|heif)$/i.test(file.name)||['image/heic','image/heif','image/heic-sequence','image/heif-sequence'].includes(file.type);
      if(file.size>maxPhotoBytes||file.size===0){this.status(this.t.photo_too_large,true);return;}
      if(!isHeic&&!['image/jpeg','image/png','image/webp'].includes(file.type)){this.status(this.t.photo_invalid,true);return;}
      try{
        let prepared=file;
        if(isHeic){this.lock(true);this.q('[data-generate-label]').textContent=this.t.preparing_photo;this.status(this.t.heic_preparing);prepared=await this.convertHeic(file);}
        this.file=prepared;this.localURL=URL.createObjectURL(prepared);
        this.q('[data-local-photo]').hidden=false;this.q('[data-local-photo] img').src=this.localURL;this.q('[data-filename]').textContent=file.name;
        this.status(isHeic?this.t.heic_ready:this.t.photo_selected);
      }catch(e){this.file=null;this.status(e instanceof Error?e.message:this.t.heic_failed,true);}
      finally{if(isHeic)this.lock(false);}
    }
    async human(action){
      if(this.demo)return 'preview';
      if(!this.session?.turnstileSiteKey)throw Error(this.t.unavailable);
      if(!window.turnstile){
        await new Promise((resolve,reject)=>{
          let script=document.querySelector('script[data-sc-turnstile]');
          if(!script){script=document.createElement('script');script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.dataset.scTurnstile='true';script.async=true;document.head.append(script);}
          script.addEventListener('load',resolve,{once:true});script.addEventListener('error',()=>reject(Error(this.t.human_failed)),{once:true});
        });
      }
      if(this.widget!==undefined)window.turnstile.remove(this.widget);
      this.status(this.t.human_wait);
      return new Promise((resolve,reject)=>{
        this.widget=window.turnstile.render(this.q('[data-human]'),{sitekey:this.session.turnstileSiteKey,action,theme:'light',callback:resolve,'error-callback':()=>reject(Error(this.t.human_failed)),'expired-callback':()=>reject(Error(this.t.human_failed))});
      });
    }
    resetPhotoSelection(){this.file=null;this.q('[data-file]').value='';this.q('[data-local-photo]').hidden=true;}
    setReference(asset){this.resetPhotoSelection();this.reference=asset;this.q('[data-reference]').hidden=false;this.q('[data-reference] img').src=asset.preview;}
    async clearReference(){
      if(this.busy)return;
      try{if(this.reference?.kind==='upload'&&!this.demo)await this.api('/assets/'+this.reference.id,{method:'DELETE'});
        this.reference=null;this.resetPhotoSelection();this.setMode('idea');this.q('[data-reference]').hidden=true;this.status(this.t.removed);
      }catch(e){this.status(e.message,true);}
    }
    async preparePhoto(){
      if(!this.file){if(this.mode==='photo'&&!this.reference)throw Error(this.t.photo_choose_first);return;}
      if(!this.q('[data-consent]').checked)throw Error(this.t.photo_choose_first);
      const file=this.file,token=await this.human('upload');this.status(this.t.uploading);
      const asset=this.demo?{id:'sample-upload',kind:'upload',preview:this.localURL}:await this.api('/upload',{method:'POST',headers:{'Content-Type':file.type,'X-Turnstile-Token':token},body:file});
      if(!asset?.id)throw Error(this.t.connection_error);
      this.setReference(asset);this.setMode('idea');this.status(this.t.photo_ready);this.q('[data-prompt]').placeholder=this.t.change_placeholder;
    }
    async upload(){
      if(this.busy)return;if(!this.file)return this.status(this.t.photo_choose_first,true);
      this.lock(true);
      try{await this.preparePhoto();this.q('[data-prompt]').focus();}catch(e){this.status(e.message,true);}finally{this.lock(false);}
    }
    async generate(){
      if(this.busy)return;
      if(!this.demo&&!this.session?.generationEnabled)return this.status(this.t.unavailable,true);
      if(this.credits<=0)return this.status(this.t.credits_empty,true);
      const prompt=this.q('[data-prompt]').value.trim();if(prompt.length<3)return this.status(this.t.prompt_required,true);
      this.lock(true);
      try{
        await this.preparePhoto();
        const token=await this.human('generate'),style=this.q('[data-style]').value;
        if(this.demo){
          const asset={id:crypto.randomUUID(),kind:'generated',preview:this.q('[data-art]').dataset.sample||this.q('[data-art]').src,width:1024,height:1024,created:Date.now(),download:false};
          this.assets.unshift(asset);this.credits--;this.updateBalance();this.select(asset);this.renderGallery();this.status(this.t.sample_status);return;
        }
        const body={prompt:prompt+(style==='none'?'':'\n'+this.t['style_prompt_'+style]),size:this.q('[data-size]').value,referenceId:this.reference?.id,requestId:crypto.randomUUID(),turnstileToken:token};
        const job=await this.api('/generate',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
        this.credits--;this.updateBalance();await this.poll(job.id);
      }catch(e){this.status(e.message,true);}finally{this.lock(false);}
    }
    async poll(id){
      if(this.polling)return;this.polling=true;this.lock(true);this.status(this.t.creating);
      try{
        for(let attempt=0;attempt<100;attempt++){
          const job=await this.api('/jobs/'+id);
          if(job.status==='complete'){
            const asset=await this.api('/assets/'+job.asset);this.assets=this.assets.filter(a=>a.id!==asset.id);this.assets.unshift(asset);this.select(asset);this.renderGallery();this.status(this.t.created);return;
          }
          if(job.status==='failed'){this.credits++;this.updateBalance();throw Error(job.error);}
          await new Promise(r=>setTimeout(r,3000));
        }
        this.status(this.t.creating);
      }catch(e){this.status(e.message,true);}finally{this.polling=false;this.lock(false);}
    }
    select(asset){
      this.selected=asset;this.q('[data-art]').src=asset.preview;this.q('[data-art]').alt=this.t.artwork_preview;
      this.q('[data-dimensions]').textContent=`${asset.width} × ${asset.height} px · ${this.t.original_pixels}`;
      this.q('[data-preview-label]').textContent=this.demo?this.t.sample:this.t.artwork_label;
      this.q('[data-download]').textContent=asset.download?this.t.download_owned:this.t.buy_download;
      this.q('.sc-art-frame').style.setProperty('--sc-art-ratio',String(asset.width/asset.height));
      this.qa('[data-gallery] button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.id===asset.id)));
    }
    renderGallery(){
      const gallery=this.q('[data-gallery]');if(!this.assets.length)return;gallery.replaceChildren();
      this.assets.forEach((asset,index)=>{
        const button=document.createElement('button');button.type='button';button.dataset.id=asset.id;button.setAttribute('aria-pressed',String(asset.id===this.selected?.id));
        button.setAttribute('aria-label',`${this.t.artwork_label} ${this.assets.length-index}`);
        const img=document.createElement('img');img.src=asset.preview;img.alt='';img.width=104;img.height=90;img.loading='lazy';
        const label=document.createElement('small');label.textContent=`${this.t.artwork_label} ${this.assets.length-index}`;
        button.append(img,label);button.addEventListener('click',()=>this.select(asset));gallery.append(button);
      });
      this.q('[data-gallery-count]').textContent=`${this.assets.length} ${this.t.saved}`;
    }
    async checkout(kind){
      if(this.demo)return this.status(this.t.sample_purchase);
      if(!this.session?.paymentsEnabled)return this.status(this.t.unavailable,true);
      if(kind==='digital'&&!this.selected)return this.status(this.t.choose_artwork,true);
      try{this.status(this.t.checkout_opening);const result=await this.api('/checkout',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({kind,assetId:kind==='digital'?this.selected.id:undefined})});
        this.status(this.t.return_note);location.assign(result.url);
      }catch(e){this.status(e.message,true);}
    }
  }
  const boot=()=>document.querySelectorAll('.sc-studio').forEach(root=>new CanvasPaletteStudio(root));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canvaspalette-unified-studio"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const maxPhotoBytes=20*1024*1024;
  let heicLoader=null;
  function loadHeicDecoder(message){
    if(typeof window.HeicTo==='function')return Promise.resolve(window.HeicTo);
    if(!heicLoader)heicLoader=new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.src='https://cdn.jsdelivr.net/npm/heic-to@1.5.2/dist/iife/heic-to.js';
      script.integrity='sha384-cVm8gaWQ5+URpoh6ACKXpm8TuyoHkfIDDBkxvDoUdIZ18w8nV5en0lVQvWMwO/6S';script.crossOrigin='anonymous';
      const fail=()=>{clearTimeout(timer);script.remove();heicLoader=null;reject(Error(message));};
      const timer=setTimeout(fail,30000);
      script.onload=()=>{if(typeof window.HeicTo!=='function')return fail();clearTimeout(timer);resolve(window.HeicTo);};
      script.onerror=fail;document.head.append(script);
    });
    return heicLoader;
  }
  class CanvasPaletteUnifiedStudio {
    constructor(root){
      if(root.dataset.initialized)return;root.dataset.initialized='true';this.root=root;
      this.t=JSON.parse(root.parentElement.querySelector('[data-studio-translations]').textContent);
      this.q=s=>root.querySelector(s);this.qa=s=>[...root.querySelectorAll(s)];
      this.demo=root.dataset.preview==='true';this.base=root.dataset.endpoint;this.assets=[];this.selected=null;this.reference=null;this.credits=3;this.busy=false;this.mode='idea';
      this.q('[data-preview-bar]').hidden=!this.demo;this.q('[data-gallery-count]').textContent=this.t.private_gallery;
      this.qa('[data-login-link]').forEach(a=>{a.href=root.dataset.login;a.target='_blank';a.rel='noopener';});
      this.setMode('idea');this.clearResult();this.bind();root.cpStudio=this;root.dispatchEvent(new CustomEvent('cp:studio-ready',{bubbles:true}));void this.load();
    }
    status(message,error=false){const node=this.q('[data-status]');node.setAttribute('role',error?'alert':'status');node.setAttribute('aria-live',error?'assertive':'polite');node.textContent=message;node.dataset.error=String(error);if(error)node.scrollIntoView({block:'nearest',behavior:'smooth'});}
    generationError(error){this.status(error.message,true);if(this.selected){this.q('[data-result-notice]').hidden=false;this.q('[data-result-notice]').textContent=this.t.previous_after_error;this.q('[data-preview-label]').textContent=this.t.previous_design;}}
    async api(path,options={}){
      const headers={'Accept':'application/json',...(this.session?.csrf?{'X-Studio-CSRF':this.session.csrf}:{}),...options.headers};
      const r=await fetch(this.base+path,{credentials:'same-origin',cache:'no-store',...options,headers});
      const data=await r.json();if(!r.ok){const e=Error(data.error||this.t.connection_error);e.status=r.status;throw e;}return data;
    }
    async load(){
      if(this.demo){this.session={credits:3,generationEnabled:true,paymentsEnabled:true};this.updateBalance();return;}
      try{
        this.session=await this.api('/session');this.credits=this.session.credits;this.assets=this.session.assets;this.renderGallery();this.updateBalance();
        this.q('[data-gate]').hidden=true;this.q('[data-login-link]').textContent=this.t.studio_account;
        const selected=this.assets.find(asset=>asset.id===this.selected?.id);
        if(selected)this.select(selected);
        if(this.session.coupon){this.q('[data-coupon]').hidden=false;this.q('[data-coupon]').textContent=this.t.coupon_message.replace('{code}',this.session.coupon);}
        if(!this.session.generationEnabled)this.status(this.t.unavailable);
        const pending=this.session.jobs?.[0];if(pending&&!this.polling)void this.poll(pending.id);
      }catch(e){if(e.status===401||e.status===403)this.q('[data-gate]').hidden=false;else this.status(this.t.unavailable);}
    }
    updateBalance(){this.q('[data-balance]').textContent=Math.max(0,this.credits);}
    lock(value){this.busy=value;this.qa('[data-generate], [data-upload], [data-file], [data-consent], [data-mode], [data-revise], [data-clear-reference], [data-new-design], [data-canvas], [data-gallery] button').forEach(el=>el.disabled=value);this.root.dispatchEvent(new CustomEvent('cp:studio-busy',{bubbles:true,detail:{busy:value}}));this.q('[data-room]').classList.toggle('is-loading',value);this.q('[data-generate-label]').textContent=value?this.t.working_label:this.t.create_art;}
    updateComposition(){this.q('[data-input-note]').textContent=this.mode==='idea'?this.t.prompt_only_note:this.reference||this.file?this.t.edit_image_note:this.t.upload_image_note;}
    setMode(mode){this.mode=mode;this.qa('[data-mode]').forEach(b=>{b.classList.toggle('is-active',b.dataset.mode===mode);b.setAttribute('aria-pressed',String(b.dataset.mode===mode));});this.q('[data-upload-panel]').hidden=mode!=='photo'||!!this.reference;this.updateComposition();}
    clearResult(){
      this.selected=null;this.q('[data-art]').removeAttribute('src');this.q('[data-dimensions]').textContent='';
      this.q('[data-result-content]').hidden=true;this.q('[data-result-empty]').hidden=false;
      this.q('[data-result-notice]').hidden=true;this.q('[data-preview-label]').textContent=this.t.new_design_label;
      this.qa('[data-gallery] button').forEach(b=>b.setAttribute('aria-pressed','false'));
    }
    startNewDesign({clearPrompt=true}={}){
      if(this.busy)return false;
      this.reference=null;this.resetPhotoSelection();this.q('[data-consent]').checked=false;
      this.q('[data-reference]').hidden=true;this.q('[data-reference] img').removeAttribute('src');
      if(this.localURL){URL.revokeObjectURL(this.localURL);this.localURL=null;}
      if(clearPrompt){this.q('[data-prompt]').value='';this.q('[data-style]').value='none';}
      this.q('[data-prompt]').placeholder=this.t.prompt_placeholder;this.setMode('idea');this.clearResult();
      this.status(this.t.new_design_ready);this.q('[data-prompt]').focus();
      this.root.dispatchEvent(new CustomEvent('cp:new-design',{bubbles:true}));return true;
    }
    bind(){
      this.qa('[data-mode]').forEach(b=>b.addEventListener('click',()=>{if(this.busy)return;if(b.dataset.mode==='idea')this.startNewDesign();else{this.setMode('photo');this.status('');}}));
      this.q('[data-new-design]').addEventListener('click',()=>this.startNewDesign());
      this.qa('[data-example]').forEach(b=>b.addEventListener('click',()=>{this.q('[data-prompt]').value=this.t['example_'+b.dataset.example];this.q('[data-prompt]').focus();}));
      this.q('[data-file]').addEventListener('change',()=>this.selectPhoto(this.q('[data-file]').files[0]));
      this.q('[data-upload]').addEventListener('click',()=>void this.upload());
      this.q('[data-clear-reference]').addEventListener('click',()=>void this.clearReference());
      this.q('[data-generate]').addEventListener('click',()=>void this.generate());
      this.q('[data-revise]').addEventListener('click',()=>{
        if(!this.selected)return this.status(this.t.choose_artwork,true);
        if(this.busy)return;this.setReference(this.selected);this.q('[data-prompt]').value='';this.q('[data-prompt]').placeholder=this.t.change_placeholder;this.q('[data-prompt]').focus();this.status(this.t.refine_ready);
      });
      this.q('[data-buy-credits]').addEventListener('click',()=>void this.checkout('credits'));
      this.q('[data-download]').addEventListener('click',()=>{
        if(!this.selected)return this.status(this.t.choose_artwork,true);
        if(this.selected.download&&!this.demo){location.assign(this.base+'/assets/'+this.selected.id+'/download');return;}
        void this.checkout('digital');
      });
      this.q('[data-canvas]').addEventListener('click',()=>{
        if(!this.selected)return this.status(this.t.choose_artwork,true);
        if(this.demo)return this.status(this.t.sample_canvas);
        if(this.busy)return;this.root.dispatchEvent(new CustomEvent('cp:use-artwork',{bubbles:true,detail:{id:this.selected.id}}));
      });
      document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible'&&!this.demo&&!this.busy)void this.load();});
      window.addEventListener('pageshow',event=>{if(event.persisted&&!this.demo&&!this.busy)void this.load();});
    }
    async convertHeic(file){
      const convert=await loadHeicDecoder(this.t.heic_load_failed);let timer;
      try{
        const blob=await Promise.race([(async()=>{
          if(!await convert.isHeic(file))throw Error(this.t.heic_failed);
          return convert({blob:file,type:'image/jpeg',quality:.98});
        })(),new Promise((_,reject)=>{timer=setTimeout(()=>reject(Error(this.t.heic_timeout)),90000);})]);
        if(!blob?.size||blob.type!=='image/jpeg')throw Error(this.t.heic_failed);
        if(blob.size>maxPhotoBytes)throw Error(this.t.heic_too_large);
        return new File([blob],file.name.replace(/\.(heic|heif)$/i,'')+'-converted.jpg',{type:'image/jpeg'});
      }finally{clearTimeout(timer);}
    }
    updatePhotoLabel(){const label=this.file||this.reference?this.t.change_image:this.t.choose_image;this.q('[data-photo-label]').textContent=label;this.q('[data-file]').setAttribute('aria-label',label);}
    async selectPhoto(file){
      if(this.busy||!file)return;
      this.aiPhoto=null;this.file=null;this.reference=null;this.q('[data-reference]').hidden=true;this.q('[data-local-photo]').hidden=true;this.q('[data-consent]').checked=false;this.setMode('photo');this.updatePhotoLabel();
      if(this.localURL){URL.revokeObjectURL(this.localURL);this.localURL=null;}
      const isHeic=/\.(heic|heif)$/i.test(file.name)||['image/heic','image/heif','image/heic-sequence','image/heif-sequence'].includes(file.type);
      if(file.size>maxPhotoBytes||file.size===0){this.status(this.t.photo_too_large,true);return;}
      if(!isHeic&&!['image/jpeg','image/png','image/webp'].includes(file.type)){this.status(this.t.photo_invalid,true);return;}
      try{
        let prepared=file;
        if(isHeic){this.lock(true);this.q('[data-generate-label]').textContent=this.t.preparing_photo;this.status(this.t.heic_preparing);prepared=await this.convertHeic(file);}
        this.file=prepared;this.updatePhotoLabel();this.updateComposition();this.localURL=URL.createObjectURL(prepared);
        this.q('[data-local-photo]').hidden=false;this.q('[data-local-photo] img').src=this.localURL;this.q('[data-filename]').textContent=file.name;
        this.status(isHeic?this.t.heic_ready:this.t.photo_selected);this.root.dispatchEvent(new CustomEvent('cp:designer-photo',{bubbles:true,detail:{file:this.file}}));
      }catch(e){this.file=null;this.status(e instanceof Error?e.message:this.t.heic_failed,true);}
      finally{if(isHeic)this.lock(false);}
    }
    async human(action){
      if(this.demo)return 'preview';
      if(!this.session?.turnstileSiteKey)throw Error(this.t.unavailable);
      if(!window.turnstile){
        await new Promise((resolve,reject)=>{
          let script=document.querySelector('script[data-sc-turnstile]');
          if(!script){script=document.createElement('script');script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.dataset.scTurnstile='true';script.async=true;document.head.append(script);}
          script.addEventListener('load',resolve,{once:true});script.addEventListener('error',()=>reject(Error(this.t.human_failed)),{once:true});
        });
      }
      if(this.widget!==undefined)window.turnstile.remove(this.widget);
      this.status(this.t.human_wait);
      return new Promise((resolve,reject)=>{
        this.widget=window.turnstile.render(this.q('[data-human]'),{sitekey:this.session.turnstileSiteKey,action,theme:'light',callback:resolve,'error-callback':()=>reject(Error(this.t.human_failed)),'expired-callback':()=>reject(Error(this.t.human_failed))});
      });
    }
    resetPhotoSelection(){this.aiPhoto=null;this.file=null;this.q('[data-file]').value='';this.q('[data-local-photo]').hidden=true;this.updatePhotoLabel();}
    setReference(asset){this.resetPhotoSelection();this.reference=asset;this.updatePhotoLabel();this.setMode('photo');this.q('[data-reference]').hidden=false;this.q('[data-reference] img').src=asset.preview;}
    async clearReference(){
      this.startNewDesign({clearPrompt:false});
    }
    async photoForAI(file){
      if(this.aiPhoto?.original===file)return this.aiPhoto.file;
      const image=new Image(),url=URL.createObjectURL(file);let canvas,bitmap;
      try{
        await new Promise((resolve,reject)=>{image.onload=resolve;image.onerror=()=>reject(Error(this.t.ai_photo_unreadable));image.src=url;});
        const width=image.naturalWidth,height=image.naturalHeight,pixels=width*height;
        if(!width||!height)throw Error(this.t.ai_photo_unreadable);
        if(pixels>100000000)throw Error(this.t.ai_photo_dimensions);
        if(pixels<=40000000)return file;
        const scale=2048/Math.max(width,height),w=Math.max(1,Math.round(width*scale)),h=Math.max(1,Math.round(height*scale));
        canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;
        const context=canvas.getContext('2d');if(!context)throw Error(this.t.ai_photo_unreadable);
        context.imageSmoothingEnabled=true;context.imageSmoothingQuality='high';
        if(typeof createImageBitmap==='function'){
          try{bitmap=await createImageBitmap(file,{resizeWidth:w,resizeHeight:h,resizeQuality:'high',imageOrientation:'from-image'});}catch{}
        }
        context.drawImage(bitmap||image,0,0,w,h);
        const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/png'));
        if(!blob?.size||blob.size>maxPhotoBytes)throw Error(this.t.ai_photo_unreadable);
        const prepared=new File([blob],'canvas-palette-ai-reference.png',{type:'image/png'});
        this.aiPhoto={original:file,file:prepared};return prepared;
      }catch(error){
        if(error.message===this.t.ai_photo_dimensions)throw error;
        throw Error(this.t.ai_photo_unreadable);
      }finally{
        bitmap?.close();if(canvas)canvas.width=canvas.height=1;
        image.onload=image.onerror=null;image.src='';URL.revokeObjectURL(url);
      }
    }
    async preparePhoto(){
      if(!this.file){if(this.mode==='photo'&&!this.reference)throw Error(this.t.photo_choose_first);return;}
      if(!this.q('[data-consent]').checked)throw Error(this.t.photo_choose_first);
      const original=this.file;this.status(this.t.ai_photo_preparing);
      const file=await this.photoForAI(original),resized=file!==original,token=await this.human('upload');this.status(this.t.uploading);
      const asset=this.demo?{id:'sample-upload',kind:'upload',preview:this.localURL}:await this.api('/upload',{method:'POST',headers:{'Content-Type':file.type,'X-Turnstile-Token':token},body:file});
      if(!asset?.id)throw Error(this.t.connection_error);
      this.setReference(asset);this.setMode('photo');this.status(resized?this.t.ai_photo_prepared:this.t.photo_ready);this.q('[data-prompt]').placeholder=this.t.change_placeholder;
    }
    async upload(){
      if(this.busy)return;if(!this.file)return this.status(this.t.photo_choose_first,true);
      this.lock(true);
      try{await this.preparePhoto();this.q('[data-prompt]').focus();}catch(e){this.generationError(e);}finally{this.lock(false);}
    }
    async generate(){
      if(this.busy)return;
      if(!this.demo&&!this.session?.generationEnabled)return this.status(this.t.unavailable,true);
      if(this.credits<=0)return this.status(this.t.credits_empty,true);
      const prompt=this.q('[data-prompt]').value.trim();if(prompt.length<3)return this.status(this.t.prompt_required,true);
      this.lock(true);
      try{
        if(this.mode==='photo')await this.preparePhoto();
        const token=await this.human('generate'),style=this.q('[data-style]').value;
        if(this.demo){
          const asset={id:crypto.randomUUID(),kind:'generated',preview:this.q('[data-art]').dataset.sample||this.q('[data-art]').src,width:1024,height:1024,created:Date.now(),download:false};
          this.assets.unshift(asset);this.credits--;this.updateBalance();this.select(asset);this.renderGallery();this.status(this.t.sample_status);return;
        }
        const body={prompt:prompt+(style==='none'?'':'\n'+this.t['style_prompt_'+style]),size:this.q('[data-size]').value,referenceId:this.mode==='photo'?this.reference?.id:undefined,requestId:crypto.randomUUID(),turnstileToken:token};
        const job=await this.api('/generate',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
        this.credits--;this.updateBalance();await this.poll(job.id);
      }catch(e){this.generationError(e);}finally{this.lock(false);}
    }
    async poll(id){
      if(this.polling)return;this.polling=true;this.lock(true);this.status(this.t.creating);
      try{
        for(let attempt=0;attempt<100;attempt++){
          const job=await this.api('/jobs/'+id);
          if(job.status==='complete'){
            const asset=await this.api('/assets/'+job.asset);this.assets=this.assets.filter(a=>a.id!==asset.id);this.assets.unshift(asset);this.select(asset);this.renderGallery();this.status(this.t.created);return;
          }
          if(job.status==='failed'){this.credits++;this.updateBalance();throw Error(job.error);}
          await new Promise(r=>setTimeout(r,3000));
        }
        this.status(this.t.creating);
      }catch(e){this.generationError(e);}finally{this.polling=false;this.lock(false);}
    }
    select(asset){
      this.q('[data-result-content]').hidden=false;this.q('[data-result-empty]').hidden=true;
      this.q('[data-result-notice]').hidden=true;this.selected=asset;this.q('[data-art]').src=asset.preview;this.q('[data-art]').alt=this.t.artwork_preview;
      this.q('[data-dimensions]').textContent=`${asset.width} × ${asset.height} px · ${this.t.original_pixels}`;
      this.q('[data-preview-label]').textContent=this.demo?this.t.sample:this.t.artwork_label;
      this.q('[data-download]').textContent=asset.download?this.t.download_owned:this.t.buy_download;
      this.q('.sc-art-frame').style.setProperty('--sc-art-ratio',String(asset.width/asset.height));
      this.qa('[data-gallery] button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.id===asset.id)));
    }
    renderGallery(){
      const gallery=this.q('[data-gallery]');if(!this.assets.length)return;gallery.replaceChildren();
      this.assets.forEach((asset,index)=>{
        const button=document.createElement('button');button.type='button';button.dataset.id=asset.id;button.setAttribute('aria-pressed',String(asset.id===this.selected?.id));
        button.setAttribute('aria-label',`${this.t.artwork_label} ${this.assets.length-index}`);
        const img=document.createElement('img');img.src=asset.preview;img.alt='';img.width=104;img.height=90;img.loading='lazy';
        const label=document.createElement('small');label.textContent=`${this.t.artwork_label} ${this.assets.length-index}`;
        button.append(img,label);button.addEventListener('click',()=>this.select(asset));gallery.append(button);
      });
      this.q('[data-gallery-count]').textContent=`${this.assets.length} ${this.t.saved}`;
    }
    async checkout(kind){
      if(this.demo)return this.status(this.t.sample_purchase);
      if(!this.session?.paymentsEnabled)return this.status(this.t.unavailable,true);
      if(kind==='digital'&&!this.selected)return this.status(this.t.choose_artwork,true);
      try{this.status(this.t.checkout_opening);const result=await this.api('/checkout',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({kind,assetId:kind==='digital'?this.selected.id:undefined})});
        this.status(this.t.return_note);location.assign(result.url);
      }catch(e){this.status(e.message,true);}
    }
  }
  const boot=()=>document.querySelectorAll('.cp-ai-studio').forEach(root=>new CanvasPaletteUnifiedStudio(root));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();


  } catch(e) { console.error(e); }
})();
})();
